import { render, staticRenderFns } from "./AddOrEdit.vue?vue&type=template&id=5d9b970d"
import script from "./AddOrEdit.vue?vue&type=script&lang=js"
export * from "./AddOrEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d9b970d')) {
      api.createRecord('5d9b970d', component.options)
    } else {
      api.reload('5d9b970d', component.options)
    }
    module.hot.accept("./AddOrEdit.vue?vue&type=template&id=5d9b970d", function () {
      api.rerender('5d9b970d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sysuser/AddOrEdit.vue"
export default component.exports